/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Status_ClearInputs */

const cs_property_lustrace_status_clear = /** @type {(inputs: Property_Lustrace_Status_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čisto`)
};

const en_property_lustrace_status_clear = /** @type {(inputs: Property_Lustrace_Status_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Property_Lustrace_Status_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_status_clear = /** @type {((inputs?: Property_Lustrace_Status_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Status_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_status_clear(inputs)
	return cs_property_lustrace_status_clear(inputs)
});